(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity controls — decrease at qty 1 removes the line
  document.querySelectorAll('.cart-item__qty-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const line = this.dataset.line;
      const input = document.querySelector(`.cart-item__qty-input[data-line="${line}"]`);
      let qty = parseInt(input.value, 10) || 0;

      if (this.dataset.action === 'increase') {
        qty++;
      } else {
        qty = Math.max(0, qty - 1);
      }

      input.value = qty;
      document.getElementById('cart-form').submit();
    });
  });

  // Remove item
  document.querySelectorAll('.cart-item__remove').forEach((btn) => {
    btn.addEventListener('click', function () {
      const line = this.dataset.line;
      const input = document.querySelector(`.cart-item__qty-input[data-line="${line}"]`);
      input.value = 0;
      document.getElementById('cart-form').submit();
    });
  });

  // Quantity input change
  document.querySelectorAll('.cart-item__qty-input').forEach((input) => {
    input.addEventListener('change', function () {
      document.getElementById('cart-form').submit();
    });
  });

  // Discount / gift card code
  (function () {
    const input = document.getElementById('cart-discount-input');
    const btn = document.getElementById('cart-discount-btn');
    const msg = document.getElementById('cart-discount-msg');
    if (!input || !btn || !msg) return;

    function showMsg(text, type) {
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.remove('is-error', 'is-success');
      if (type) msg.classList.add(type);
    }

    function applyDiscount() {
      const code = (input.value || '').trim();
      if (!code) {
        showMsg('Please enter a discount code.', 'is-error');
        input.focus();
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Applying…';
      showMsg('Applying discount…', '');

      const redirect = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + redirect;
    }

    btn.addEventListener('click', applyDiscount);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount();
      }
    });
  })();

  // Checkout — model confirm only for Smart Throttle carts
  (function () {
    const checkoutBtn = document.getElementById('cart-checkout-btn');
    if (!checkoutBtn) return;

    const modal = document.getElementById('car-confirm-modal');

    function goToCheckout() {
      window.location.href = '/checkout';
    }

    if (!modal) {
      checkoutBtn.addEventListener('click', goToCheckout);
      return;
    }

    const form = document.getElementById('car-confirm-form');
    const submitBtn = document.getElementById('car-confirm-submit');
    const errorEl = document.getElementById('car-confirm-error');

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const first = modal.querySelector('input, select');
      if (first) first.focus();
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      errorEl.hidden = true;
      submitBtn.disabled = false;
      submitBtn.textContent = 'Confirm & Proceed';
    }

    checkoutBtn.addEventListener('click', openModal);

    modal.querySelectorAll('[data-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const modelName = form.model_name.value.trim();

      if (!modelName) {
        errorEl.textContent = 'Model name is required.';
        errorEl.hidden = false;
        return;
      }
      errorEl.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Saving…';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Model Name': modelName,
          },
        }),
      })
        .then((r) => r.json())
        .then(() => {
          goToCheckout();
        })
        .catch(() => {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Confirm & Proceed';
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-with-filters"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilters {
    constructor() {
      this.activeFilters = {
        tags: [],
        price: { min: null, max: null },
        search: '',
      };
      this.init();
    }

    init() {
      // Filter toggle
      document.querySelectorAll('.filter-header').forEach((header) => {
        header.addEventListener('click', () => {
          const expanded = header.getAttribute('aria-expanded') === 'true';
          header.setAttribute('aria-expanded', !expanded);
        });
      });

      // View toggle
      document.querySelectorAll('.view-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const view = btn.dataset.view;
          document.querySelectorAll('.view-btn').forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
          document.querySelector('.products-grid').dataset.view = view;
        });
      });

      // Checkbox filters
      document.querySelectorAll('.filter-checkbox input').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          this.updateTagFilters();
          this.applyFilters();
        });
      });

      // Dropdown filters
      document.querySelectorAll('.filter-select').forEach((select) => {
        select.addEventListener('change', () => {
          this.updateTagFilters();
          this.applyFilters();
        });
      });

      // Price filters
      const minSlider = document.querySelector('.price-slider-min');
      const maxSlider = document.querySelector('.price-slider-max');
      const minInput = document.getElementById('price-min');
      const maxInput = document.getElementById('price-max');

      if (minSlider && maxSlider) {
        minSlider.addEventListener('input', (e) => {
          const val = parseInt(e.target.value);
          if (val >= parseInt(maxSlider.value)) {
            e.target.value = parseInt(maxSlider.value) - 10;
          }
          minInput.value = e.target.value;
        });

        maxSlider.addEventListener('input', (e) => {
          const val = parseInt(e.target.value);
          if (val <= parseInt(minSlider.value)) {
            e.target.value = parseInt(minSlider.value) + 10;
          }
          maxInput.value = e.target.value;
        });

        minInput.addEventListener('input', (e) => {
          minSlider.value = e.target.value;
        });

        maxInput.addEventListener('input', (e) => {
          maxSlider.value = e.target.value;
        });

        document.querySelector('.apply-price-btn').addEventListener('click', () => {
          this.activeFilters.price.min = minInput.value ? parseInt(minInput.value) : null;
          this.activeFilters.price.max = maxInput.value ? parseInt(maxInput.value) : null;
          this.applyFilters();
        });
      }

      // Search (in-page only)
      const searchInput = document.getElementById('collection-search');
      let searchTimeout;
      searchInput.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          this.activeFilters.search = e.target.value.toLowerCase();
          this.applyFilters();
        }, 300);
      });

      // Sort
      document.getElementById('collection-sort').addEventListener('change', (e) => {
        this.sortProducts(e.target.value);
      });

      // Clear all filters
      const clearBtn = document.querySelector('.clear-filters-btn');
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          this.clearAllFilters();
        });
      }
    }

    updateTagFilters() {
      const tags = [];

      // Get checked checkboxes
      document.querySelectorAll('.filter-checkbox input:checked').forEach((cb) => {
        tags.push({
          value: cb.value.toLowerCase(),
          label: cb.value,
          name: cb.dataset.filterName,
        });
      });

      // Get selected dropdowns
      document.querySelectorAll('.filter-select').forEach((select) => {
        if (select.value) {
          tags.push({
            value: select.value.toLowerCase(),
            label: select.value,
            name: select.dataset.filterName,
          });
        }
      });

      this.activeFilters.tags = tags;
    }

    applyFilters() {
      const products = document.querySelectorAll('.product-card');
      let visibleCount = 0;

      products.forEach((product) => {
        let show = true;

        // Tag filter
        if (this.activeFilters.tags.length > 0) {
          const productTags = product.dataset.tags.toLowerCase();
          const productTitle = product.dataset.title.toLowerCase();

          show = this.activeFilters.tags.every((filter) => {
            return productTags.includes(filter.value) || productTitle.includes(filter.value);
          });
        }

        // Price filter
        if (show && (this.activeFilters.price.min || this.activeFilters.price.max)) {
          const price = parseInt(product.dataset.price);
          if (this.activeFilters.price.min && price < this.activeFilters.price.min) {
            show = false;
          }
          if (this.activeFilters.price.max && price > this.activeFilters.price.max) {
            show = false;
          }
        }

        // Search filter
        if (show && this.activeFilters.search) {
          const title = product.dataset.title;
          const tags = product.dataset.tags;
          show = title.includes(this.activeFilters.search) || tags.includes(this.activeFilters.search);
        }

        if (show) {
          product.classList.remove('hidden');
          visibleCount++;
        } else {
          product.classList.add('hidden');
        }
      });

      // Update no results message
      const noResults = document.querySelector('.no-results');
      if (visibleCount === 0) {
        noResults.style.display = 'block';
      } else {
        noResults.style.display = 'none';
      }

      // Update active filters display
      this.updateActiveFiltersDisplay();

      // Show/hide clear button
      const hasFilters =
        this.activeFilters.tags.length > 0 ||
        this.activeFilters.price.min ||
        this.activeFilters.price.max ||
        this.activeFilters.search;
      document.querySelector('.clear-filters-btn').style.display = hasFilters ? 'block' : 'none';
    }

    updateActiveFiltersDisplay() {
      const container = document.querySelector('.active-filters');
      const list = document.querySelector('.active-filters-list');
      list.innerHTML = '';

      let hasFilters = false;

      // Tag badges
      this.activeFilters.tags.forEach((filter) => {
        hasFilters = true;
        const badge = document.createElement('div');
        badge.className = 'filter-badge';
        badge.innerHTML = `
          <span>${filter.label}</span>
          <button class="filter-badge-remove" data-type="tag" data-value="${filter.value}">
            <svg width="12" height="12" viewBox="0 0 12 12"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="2"/></svg>
          </button>
        `;
        list.appendChild(badge);
      });

      // Price badge
      if (this.activeFilters.price.min || this.activeFilters.price.max) {
        hasFilters = true;
        const min = this.activeFilters.price.min || '0';
        const max = this.activeFilters.price.max || '∞';
        const badge = document.createElement('div');
        badge.className = 'filter-badge';
        badge.innerHTML = `
          <span>₹${min} - ₹${max}</span>
          <button class="filter-badge-remove" data-type="price">
            <svg width="12" height="12" viewBox="0 0 12 12"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="2"/></svg>
          </button>
        `;
        list.appendChild(badge);
      }

      // Search badge
      if (this.activeFilters.search) {
        hasFilters = true;
        const badge = document.createElement('div');
        badge.className = 'filter-badge';
        badge.innerHTML = `
          <span>Search: "${this.activeFilters.search}"</span>
          <button class="filter-badge-remove" data-type="search">
            <svg width="12" height="12" viewBox="0 0 12 12"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="2"/></svg>
          </button>
        `;
        list.appendChild(badge);
      }

      container.style.display = hasFilters ? 'block' : 'none';

      // Add remove listeners
      list.querySelectorAll('.filter-badge-remove').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.removeFilter(btn.dataset.type, btn.dataset.value);
        });
      });
    }

    removeFilter(type, value) {
      if (type === 'tag') {
        // Uncheck checkbox or clear dropdown
        const checkbox = document.querySelector(`.filter-checkbox input[value="${value}"]`);
        if (checkbox) {
          checkbox.checked = false;
        }
        const dropdown = Array.from(document.querySelectorAll('.filter-select')).find(
          (s) => s.value.toLowerCase() === value
        );
        if (dropdown) {
          dropdown.value = '';
        }
        this.updateTagFilters();
      } else if (type === 'price') {
        this.activeFilters.price = { min: null, max: null };
        document.getElementById('price-min').value = '';
        document.getElementById('price-max').value = '';
      } else if (type === 'search') {
        this.activeFilters.search = '';
        document.getElementById('collection-search').value = '';
      }
      this.applyFilters();
    }

    clearAllFilters() {
      // Clear checkboxes
      document.querySelectorAll('.filter-checkbox input:checked').forEach((cb) => (cb.checked = false));

      // Clear dropdowns
      document.querySelectorAll('.filter-select').forEach((s) => (s.value = ''));

      // Clear price
      document.getElementById('price-min').value = '';
      document.getElementById('price-max').value = '';

      // Clear search
      document.getElementById('collection-search').value = '';

      // Reset active filters
      this.activeFilters = {
        tags: [],
        price: { min: null, max: null },
        search: '',
      };

      this.applyFilters();
    }

    sortProducts(sortBy) {
      const grid = document.querySelector('.products-grid');
      const products = Array.from(grid.querySelectorAll('.product-card'));

      products.sort((a, b) => {
        switch (sortBy) {
          case 'price-ascending':
            return parseInt(a.dataset.price) - parseInt(b.dataset.price);
          case 'price-descending':
            return parseInt(b.dataset.price) - parseInt(a.dataset.price);
          case 'title-ascending':
            return a.dataset.title.localeCompare(b.dataset.title);
          case 'title-descending':
            return b.dataset.title.localeCompare(a.dataset.title);
          default:
            return 0;
        }
      });

      products.forEach((product) => grid.appendChild(product));
    }
  }

  // Initialize filters
  new CollectionFilters();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealer-distributor-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.section-dealer-distributor-search');

    const earthRadiusKm = 6371;

    const toRadians = (value) => (value * Math.PI) / 180;

    const distanceKm = (a, b) => {
      const dLat = toRadians(b.lat - a.lat);
      const dLng = toRadians(b.lng - a.lng);
      const lat1 = toRadians(a.lat);
      const lat2 = toRadians(b.lat);

      const x =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);

      return 2 * earthRadiusKm * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
    };

    const geocodeCache = new Map();

    const geocodeQuery = async (query) => {
      if (!query) {
        return null;
      }

      const normalizedQuery = query.trim();
      if (geocodeCache.has(normalizedQuery)) {
        return geocodeCache.get(normalizedQuery);
      }

      const normalizedWithCountry = /\bindia\b/i.test(normalizedQuery) ? normalizedQuery : `${normalizedQuery}, India`;
      const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&addressdetails=1&q=${encodeURIComponent(
        normalizedWithCountry
      )}`;

      try {
        const response = await fetch(url, {
          headers: {
            Accept: 'application/json',
            'Accept-Language': 'en',
          },
        });

        if (!response.ok) {
          geocodeCache.set(normalizedQuery, null);
          return null;
        }

        const result = await response.json();

        if (!Array.isArray(result) || !result.length) {
          geocodeCache.set(normalizedQuery, null);
          return null;
        }

        const coords = {
          lat: Number(result[0].lat),
          lng: Number(result[0].lon),
        };

        geocodeCache.set(normalizedQuery, coords);
        return coords;
      } catch (error) {
        geocodeCache.set(normalizedQuery, null);
        return null;
      }
    };

    const waitForLeaflet = (tries) =>
      new Promise((resolve) => {
        if (window.L) {
          resolve(true);
          return;
        }

        if (tries <= 0) {
          resolve(false);
          return;
        }

        setTimeout(async () => {
          const loaded = await waitForLeaflet(tries - 1);
          resolve(loaded);
        }, 120);
      });

    sections.forEach(async (section) => {
      if (section.dataset.dealerSearchReady === 'true') {
        return;
      }
      section.dataset.dealerSearchReady = 'true';

      const mapCanvas = section.querySelector('[data-map-canvas]');
      const status = section.querySelector('[data-status]');
      const locateButton = section.querySelector('[data-locate-button]');
      const searchInput = section.querySelector('.dealer-search__search');
      const noResults = section.querySelector('[data-no-results]');
      const configNode = section.querySelector('[data-dealer-config]');
      const items = Array.from(section.querySelectorAll('[data-result-item]'));

      const nearbyRadiusKm = Number(configNode?.dataset.nearbyRadiusKm || 20) || 20;
      const defaultQuery = configNode?.dataset.defaultQuery || 'India';
      const defaultZoom = Number(configNode?.dataset.defaultZoom || 5) || 5;
      const nearbyEnabled = configNode?.dataset.nearbyEnabled === 'true';

      const loaded = await waitForLeaflet(50);
      if (!loaded || !mapCanvas) {
        if (status) {
          status.textContent = section.dataset.msgMapUnavailable || 'Map is unavailable right now.';
        }
        return;
      }

      const map = L.map(mapCanvas, {
        zoomControl: true,
      }).setView([20.5937, 78.9629], defaultZoom);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(map);

      const markerLayer = L.layerGroup().addTo(map);
      let userMarker = null;
      let userCircle = null;
      let userPosition = null;

      const createMarkerIcon = (fill, stroke, scale) =>
        L.divIcon({
          className: 'dealer-search__marker-icon',
          html: `
            <svg width="${24 * scale}" height="${36 * scale}" viewBox="0 0 24 36" aria-hidden="true" focusable="false">
              <path d="M12 35s9-10.2 9-19.2C21 7.4 17 2 12 2S3 7.4 3 15.8C3 24.8 12 35 12 35Z" fill="${fill}" stroke="${stroke}" stroke-width="1.5" />
              <circle cx="12" cy="15" r="4.3" fill="#0f1b2e" opacity="0.95" />
            </svg>
          `,
          iconSize: [24 * scale, 36 * scale],
          iconAnchor: [12 * scale, 35 * scale],
          popupAnchor: [0, -30 * scale],
        });

      const dealerIcon = createMarkerIcon('#6ee7ff', '#eff6ff', 1);
      const userIcon = createMarkerIcon('#8be3af', '#eff6ff', 1.15);

      const entries = items.map((item) => ({
        item,
        marker: null,
        coords: null,
        query: item.dataset.mapQuery || '',
        searchIndex: item.dataset.searchIndex || '',
      }));

      const setStatus = (text) => {
        if (status) {
          status.textContent = text;
        }
      };

      const parseManualCoords = (entry) => {
        const lat = Number(entry.item.dataset.latitude || '');
        const lng = Number(entry.item.dataset.longitude || '');

        if (!Number.isNaN(lat) && !Number.isNaN(lng) && lat !== 0 && lng !== 0) {
          return { lat, lng };
        }

        return null;
      };

      const ensureEntryCoords = async (entry) => {
        if (entry.coords) {
          return entry.coords;
        }

        const manualCoords = parseManualCoords(entry);
        if (manualCoords) {
          entry.coords = manualCoords;
          return entry.coords;
        }

        const geocoded = await geocodeQuery(entry.query);
        if (geocoded) {
          entry.coords = geocoded;
        }

        return entry.coords;
      };

      const popupHtml = (entry) => {
        const name = entry.item.dataset.name || '';
        const type = entry.item.dataset.type || '';
        const area = entry.item.dataset.area || '';
        const address = entry.item.dataset.address || '';
        const contact = entry.item.dataset.contact || '';

        return `<strong>${name}</strong><br>${type}<br>${area}<br>${address}<br>${contact}`;
      };

      const renderMarkers = (visibleEntries) => {
        markerLayer.clearLayers();

        const boundsPoints = [];

        visibleEntries.forEach((entry) => {
          if (!entry.coords) {
            return;
          }

          const marker = L.marker([entry.coords.lat, entry.coords.lng], {
            icon: dealerIcon,
            title: entry.item.dataset.name || entry.item.dataset.address || '',
          });
          marker.bindPopup(popupHtml(entry));
          marker.addTo(markerLayer);
          entry.marker = marker;
          boundsPoints.push([entry.coords.lat, entry.coords.lng]);
        });

        if (userPosition) {
          if (!userMarker) {
            userMarker = L.marker([userPosition.lat, userPosition.lng], { icon: userIcon }).addTo(map);
          } else {
            userMarker.setLatLng([userPosition.lat, userPosition.lng]);
          }

          if (!userCircle) {
            userCircle = L.circle([userPosition.lat, userPosition.lng], {
              radius: nearbyRadiusKm * 1000,
              color: '#8be3af',
              fillColor: '#8be3af',
              fillOpacity: 0.09,
            }).addTo(map);
          } else {
            userCircle.setLatLng([userPosition.lat, userPosition.lng]);
            userCircle.setRadius(nearbyRadiusKm * 1000);
          }

          const circleBounds = userCircle.getBounds();
          map.fitBounds(circleBounds.pad(0.2), { maxZoom: 11 });
          return;
        }

        if (boundsPoints.length) {
          map.fitBounds(boundsPoints, {
            padding: [30, 30],
            maxZoom: 13,
          });
        }
      };

      let nearbyMode = nearbyEnabled;

      const applyFilters = () => {
        const textQuery = (searchInput?.value || '').trim().toLowerCase();
        const visible = [];

        entries.forEach((entry) => {
          const matchesSearch = textQuery === '' || entry.searchIndex.indexOf(textQuery) !== -1;
          let matchesNearby = true;

          const distanceNode = entry.item.querySelector('[data-distance]');
          if (distanceNode) {
            distanceNode.hidden = true;
            distanceNode.textContent = '';
          }

          if (nearbyMode && userPosition) {
            if (entry.coords) {
              const km = distanceKm(userPosition, entry.coords);
              matchesNearby = km <= nearbyRadiusKm;

              if (distanceNode && matchesNearby) {
                distanceNode.hidden = false;
                distanceNode.textContent = `${section.dataset.msgDistanceLabel || 'Distance'}: ${km.toFixed(1)} km`;
              }
            } else {
              matchesNearby = false;
            }
          }

          const isVisible = matchesSearch && matchesNearby;
          entry.item.hidden = !isVisible;

          if (isVisible) {
            visible.push(entry);
          }
        });

        if (noResults) {
          noResults.hidden = visible.length > 0;
        }

        if (nearbyMode && userPosition) {
          setStatus(
            `${section.dataset.msgNearbyPrefix || 'Showing nearby within'} ${nearbyRadiusKm} km (${visible.length})`
          );
        } else {
          setStatus(section.dataset.msgMapReady || 'Map ready.');
        }

        renderMarkers(visible);
      };

      const resolveAllEntries = async () => {
        setStatus(section.dataset.msgMapLoading || 'Loading map and locations...');

        await Promise.all(entries.map((entry) => ensureEntryCoords(entry)));
      };

      const locateUser = () => {
        if (!navigator.geolocation) {
          setStatus(section.dataset.msgLocationUnavailable || 'Location is not supported on this browser.');
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (position) => {
            userPosition = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            nearbyMode = true;
            applyFilters();
          },
          () => {
            setStatus(section.dataset.msgLocationDenied || 'Location permission denied.');
            nearbyMode = false;
            applyFilters();
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 60000,
          }
        );
      };

      section.querySelectorAll('[data-map-button]').forEach((button) => {
        button.addEventListener('click', async () => {
          const item = button.closest('[data-result-item]');
          const entry = entries.find((current) => current.item === item);
          if (!entry) {
            return;
          }

          if (!entry.coords) {
            entry.coords = await ensureEntryCoords(entry);
          }

          if (!entry.coords) {
            setStatus(section.dataset.msgMapUnavailable || 'Map is unavailable right now.');
            return;
          }

          map.setView([entry.coords.lat, entry.coords.lng], 13);
          if (entry.marker) {
            entry.marker.openPopup();
          }
        });
      });

      searchInput?.addEventListener('input', applyFilters);
      locateButton?.addEventListener('click', locateUser);

      const defaultCoords = await geocodeQuery(defaultQuery);
      if (defaultCoords) {
        map.setView([defaultCoords.lat, defaultCoords.lng], defaultZoom);
      }

      await resolveAllEntries();
      applyFilters();
      locateUser();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', function() {
    const item = btn.closest('.faq-item');
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !expanded);
    item.classList.toggle('open', !expanded);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  const menuToggle = document.querySelector('.site-header__menu-toggle');
  const nav = document.querySelector('.site-header__nav');
  const overlay = document.querySelector('.site-header__nav-overlay');
  const closeBtn = document.querySelector('.site-header__nav-close');
  const body = document.body;
  
  function toggleMenu() {
    const isActive = nav.classList.toggle('active');
    overlay.classList.toggle('active');
    menuToggle.setAttribute('aria-expanded', isActive);
    
    if (isActive) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = '';
    }
  }
  
  if (menuToggle && nav && overlay) {
    menuToggle.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', toggleMenu);
    
    if (closeBtn) {
      closeBtn.addEventListener('click', toggleMenu);
    }
    
    // Close menu on link click
    const menuLinks = nav.querySelectorAll('.site-header__menu-item a');
    menuLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (nav.classList.contains('active')) {
          toggleMenu();
        }
      });
    });
    
    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('active')) {
        toggleMenu();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuToggle = document.querySelector('.site-header__menu-toggle');
  const nav = document.querySelector('.site-header__nav');
  const overlay = document.querySelector('.site-header__nav-overlay');
  const closeBtn = document.querySelector('.site-header__nav-close');

  function toggleMenu() {
    const isActive = nav.classList.toggle('active');
    overlay.classList.toggle('active');
    menuToggle.setAttribute('aria-expanded', isActive);
    document.body.style.overflow = isActive ? 'hidden' : '';
  }

  if (menuToggle && nav && overlay && closeBtn) {
    menuToggle.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', toggleMenu);
    closeBtn.addEventListener('click', toggleMenu);

    // Close on link click
    nav.querySelectorAll('.site-header__menu-item a').forEach((link) => {
      link.addEventListener('click', () => {
        if (nav.classList.contains('active')) toggleMenu();
      });
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('active')) toggleMenu();
    });
  }

  // User menu dropdown
  const userToggle = document.querySelector('.site-header__user-toggle');
  const userMenu = document.querySelector('.site-header__user-menu');

  if (userToggle && userMenu) {
    userToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isActive = userMenu.classList.toggle('active');
      userToggle.setAttribute('aria-expanded', isActive);
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!userMenu.contains(e.target)) {
        userMenu.classList.remove('active');
        userToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && userMenu.classList.contains('active')) {
        userMenu.classList.remove('active');
        userToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-warranty"]) return;
  try {
    
  // Quantity +/-
  document.querySelectorAll('.warranty-product__qty-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.warranty-product__qty-input');
      let val = parseInt(input.value, 10) || 1;
      if (this.textContent.trim() === '+') {
        val++;
      } else if (val > 1) {
        val--;
      }
      input.value = val;
    });
  });

  // Wishlist toggle
  const wishlistBtn = document.querySelector('.wishlist-btn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      this.classList.toggle('active');
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Coupon banner carousel — swipe + autoplay when 2+ coupons
  (function () {
    const carousel = document.querySelector('[data-coupon-carousel]');
    if (!carousel) return;
    const viewport = carousel.querySelector('[data-coupon-viewport]');
    const track = carousel.querySelector('[data-coupon-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-coupon-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-coupon-dot]'));
    if (!viewport || !track || slides.length < 2) return;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    const intervalMs = parseInt(carousel.dataset.interval, 10) || 4000;
    let timer = null;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let dragging = false;
    let lockedAxis = null;
    const threshold = 40;

    function setTransform(offsetPx, withTransition) {
      if (!withTransition) carousel.classList.add('is-dragging');
      else carousel.classList.remove('is-dragging');
      track.style.transform = 'translate3d(' + offsetPx + 'px, 0, 0)';
    }

    function goTo(next, animate) {
      index = ((next % slides.length) + slides.length) % slides.length;
      const width = viewport.clientWidth || 0;
      setTransform(-index * width, animate !== false);
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function start() {
      stop();
      timer = setInterval(() => goTo(index + 1), intervalMs);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      deltaX = 0;
      dragging = true;
      lockedAxis = null;
      stop();
      try {
        viewport.setPointerCapture(pointerId);
      } catch (err) {}
      carousel.classList.add('is-dragging');
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (!lockedAxis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (lockedAxis === 'y') {
          dragging = false;
          carousel.classList.remove('is-dragging');
          start();
          return;
        }
      }
      if (lockedAxis !== 'x') return;
      e.preventDefault();
      deltaX = dx;
      const width = viewport.clientWidth || 0;
      setTransform(-index * width + deltaX, false);
    }

    function onPointerUp(e) {
      if (e.pointerId !== pointerId) return;
      const wasDragging = dragging;
      dragging = false;
      pointerId = null;
      carousel.classList.remove('is-dragging');
      if (!wasDragging) {
        start();
        return;
      }
      if (Math.abs(deltaX) > threshold) {
        goTo(deltaX < 0 ? index + 1 : index - 1, true);
      } else {
        goTo(index, true);
      }
      deltaX = 0;
      lockedAxis = null;
      start();
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i, true);
        start();
      });
    });

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('lostpointercapture', onPointerUp);

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    window.addEventListener('resize', () => goTo(index, false));

    goTo(index, false);
    start();
  })();

  // Product image slider
  const thumbnails = document.querySelectorAll('.product-page__thumbnail');
  const mainImage = document.getElementById('product-main-image');
  let currentIndex = 0;
  if (thumbnails.length && mainImage) {
    function showImage(idx) {
      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === idx);
      });
      const img = thumbnails[idx].querySelector('img');
      const fullSrc = img && img.dataset.fullSrc;
      if (fullSrc) mainImage.src = fullSrc;
      currentIndex = idx;
    }
    thumbnails.forEach((thumb, i) => {
      thumb.addEventListener('click', () => showImage(i));
    });
    document.querySelector('.product-page__gallery-arrow--up')?.addEventListener('click', () => {
      showImage((currentIndex - 1 + thumbnails.length) % thumbnails.length);
    });
    document.querySelector('.product-page__gallery-arrow--down')?.addEventListener('click', () => {
      showImage((currentIndex + 1) % thumbnails.length);
    });
  }

  // Copy link share
  const copyBtn = document.querySelector('.social-icon--copy');
  if (copyBtn) {
    const socials = copyBtn.closest('.product-page__socials');
    const toast = socials?.querySelector('.copy-toast');
    const shareUrl = socials?.dataset.shareUrl || window.location.href;
    copyBtn.addEventListener('click', async () => {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(shareUrl);
        } else {
          const ta = document.createElement('textarea');
          ta.value = shareUrl;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        copyBtn.classList.add('is-copied');
        toast?.classList.add('is-visible');
        setTimeout(() => {
          copyBtn.classList.remove('is-copied');
          toast?.classList.remove('is-visible');
        }, 1800);
      } catch (e) {
        console.error('Copy failed', e);
      }
    });
  }

  // Quantity +/-
  document.querySelectorAll('.product-page__qty-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('input[type="number"]');
      let val = parseInt(input.value, 10) || 1;
      if (this.textContent.trim() === '+') val++;
      else if (val > 1) val--;
      input.value = val;
    });
  });

  // Wishlist functionality with localStorage
  const wishlistBtn = document.querySelector('.wishlist-btn');
  if (wishlistBtn) {
    const productId = '{{ product.id }}';
    const productTitle = '{{ product.title | escape }}';
    const productPrice = '{{ product.price | money }}';
    const productImage = '{{ product.featured_image | image_url: width: 300 }}';
    const productUrl = '{{ product.url }}';

    // Check if product is already in wishlist
    function isInWishlist() {
      const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      return wishlist.some((item) => item.id === productId);
    }

    // Update heart appearance
    function updateHeartAppearance() {
      const heart = wishlistBtn.querySelector('.wishlist-heart');
      if (isInWishlist()) {
        wishlistBtn.classList.add('active');
        heart.setAttribute('fill', '#e11d48');
        heart.setAttribute('stroke', '#e11d48');
      } else {
        wishlistBtn.classList.remove('active');
        heart.setAttribute('fill', 'none');
        heart.setAttribute('stroke', 'currentColor');
      }
    }

    // Initialize on page load
    updateHeartAppearance();

    wishlistBtn.addEventListener('click', function () {
      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

      if (isInWishlist()) {
        // Remove from wishlist
        wishlist = wishlist.filter((item) => item.id !== productId);
      } else {
        // Add to wishlist
        wishlist.push({
          id: productId,
          title: productTitle,
          price: productPrice,
          image: productImage,
          url: productUrl,
        });
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      updateHeartAppearance();
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  // Load and display wishlist items
  function loadWishlist() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const itemsContainer = document.getElementById('wishlist-items');
    const emptyState = document.getElementById('wishlist-empty');

    if (wishlist.length === 0) {
      itemsContainer.style.display = 'none';
      emptyState.style.display = 'block';
      return;
    }

    itemsContainer.style.display = 'grid';
    emptyState.style.display = 'none';

    itemsContainer.innerHTML = wishlist
      .map(
        (item) => `
      <div class="wishlist-item" data-id="${item.id}">
        <div class="wishlist-item__image">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="wishlist-item__info">
          <a href="${item.url}" class="wishlist-item__title">${item.title}</a>
          <div class="wishlist-item__price">${item.price}</div>
          <div class="wishlist-item__actions">
            <button class="wishlist-item__add-to-cart" data-id="${item.id}">Add to Cart</button>
            <button class="wishlist-item__remove" data-id="${item.id}" aria-label="Remove">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `
      )
      .join('');

    // Add event listeners for remove buttons
    document.querySelectorAll('.wishlist-item__remove').forEach((btn) => {
      btn.addEventListener('click', function () {
        const productId = this.dataset.id;
        removeFromWishlist(productId);
      });
    });

    // Add event listeners for add to cart buttons
    document.querySelectorAll('.wishlist-item__add-to-cart').forEach((btn) => {
      btn.addEventListener('click', function () {
        const productId = this.dataset.id;
        addToCart(productId);
      });
    });
  }

  function removeFromWishlist(productId) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    wishlist = wishlist.filter((item) => item.id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    loadWishlist();
  }

  function addToCart(productId) {
    // This would need to be implemented with proper Shopify variant IDs
    // For now, just redirect to the product page
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const item = wishlist.find((i) => i.id === productId);
    if (item) {
      window.location.href = item.url;
    }
  }

  // Load wishlist on page load
  loadWishlist();

  } catch(e) { console.error(e); }
})();
})();
